import React, { useEffect, useState } from "react";
import "./chatbot.scss";
import Chatbotheader from "./chatbotheader";
import Chatbotbody from "./chatbotbody";
import Chatbotfooter from "./chatbotfooter";
import BackGroundImage from "../../assets/images/chat-body.png";
import { useDispatch, useSelector } from "react-redux";
import {
  getBrandInfo,
  setSelectedProject,
} from "../../store/slices/projectSlice";
import { useLocation, useParams } from "react-router-dom";
import { newShade } from "../../common/validation";
import { getUploadedFile } from "../../store/slices/embeddingSlice";

export default function Chatbot({ userChatById, isKnowledgeChat, selectedUser }) {
  const { selectedProject } = useSelector((state) => state.project);
  const [tempUserData, setTempUserData] = useState("");
  const [chatWithBot, setChatWithBot] = useState([]);
  const [bgImage, setBgImage] = useState();
  useEffect(() => {
    let objectUrl = null;

    if (selectedProject?.background_image instanceof Blob ||
      selectedProject?.background_image instanceof File) {
      objectUrl = URL.createObjectURL(selectedProject?.background_image);
      setBgImage(objectUrl);
    } else if (typeof selectedProject?.background_image === "string" && selectedProject?.background_image) {
      setBgImage(selectedProject?.background_image);
    } else {
      setBgImage(BackGroundImage);
    }

    // Cleanup function to revoke object URL when component unmounts or image changes
    return () => {
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
      }
    };
  }, [selectedProject?.background_image]);

  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const { id } = useParams();
  const [brandInfoLoaded, setBrandInfoLoaded] = useState(false);

  useEffect(() => {
    // Only fetch brand info once when on chat pages
    if ((pathname.includes("generalchat") || pathname.includes("/chat/")) && id && !brandInfoLoaded) {
      const body = { id: id };
      dispatch(getBrandInfo(body))
        .unwrap()
        .then((res) => {
          if (res?.data?.data) {
            dispatch(setSelectedProject(res?.data?.data));
            setBrandInfoLoaded(true);
          }
        });
    }
  }, [dispatch, id, pathname, brandInfoLoaded]);


  useEffect(() => {
    if (selectedProject?.id) {
      const body = {
        offset: 0,
        project_id: selectedProject?.id,
      };
      dispatch(getUploadedFile(body));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedProject?.id]);

  const BgColor = selectedProject?.base_color?.includes("gradient")
    ? selectedProject?.base_color
    : newShade(selectedProject?.base_color, 80);

  // Set scrollbar color dynamically based on project base_color
  useEffect(() => {
    if (selectedProject?.base_color) {
      const scrollbarColor = selectedProject.base_color.includes("gradient") 
        ? selectedProject.base_color 
        : `linear-gradient(180deg, ${BgColor} 0%, ${selectedProject.base_color} 100%)`;
      
      document.documentElement.style.setProperty('--theme-scrollbar-color', scrollbarColor);
    }
  }, [selectedProject?.base_color, BgColor]);

  // Detect standalone fullscreen mode (generalchat or /chat/ routes)
  const isFullScreen = pathname.includes("generalchat") || pathname.includes("/chat/");

  return (
    <div
      className={`chat-bot-design ${isFullScreen ? 'full-width-screen' : 'chat-bot-design-lg'}`}
      style={{
        backgroundImage: bgImage && bgImage !== BackGroundImage ? `url(${bgImage})` : 'none',
        backgroundColor: '#F8F9FA'
      }}
    >
      <Chatbotheader
        BgColor={BgColor}
        tempUserData={tempUserData}
        setTempUserData={setTempUserData}
        chatWithBot={chatWithBot}
        setChatWithBot={setChatWithBot}
      />
      <Chatbotbody
        userChatById={userChatById}
        isKnowledgeChat={isKnowledgeChat}
        tempUserData={tempUserData}
        setTempUserData={setTempUserData}
        chatWithBot={chatWithBot}
        setChatWithBot={setChatWithBot}
        selectedUser={selectedUser}
        BgColor={BgColor}
      />
      <Chatbotfooter BgColor={BgColor} />
    </div>
  );
}
